module.exports = __webpack_public_path__ + "img/logo-lv.529f73bf.png";